import React, { createContext, useReducer } from "react"
import { USER, SERVICE_LIST } from "./types"

const initialState = {
  userData: "",
  serviceList: [],
}

const store = createContext(initialState)
const { Provider } = store

const reducer = (state, action) => {
  switch (action.type) {
    case USER:
      return {
        ...state,
        userData: action.payload,
      }
    case SERVICE_LIST:
      return {
        ...state,
        serviceList: action.payload,
      }

    default:
      return state
  }
}

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return <Provider value={{ state, dispatch }}>{children}</Provider>
}

export { store, StateProvider }
